import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const headerClient = (data) => {
  const client = data?.real_estate?.name

  if (!client) return ''

  return `
    <div class="d-block mt-3">
      <h6 class="text-uppercase grey--text mt-2">
        ${translate(area + 'client')}
      </h6>
      <span class="body-2">
        ${client}
      </span>
    </div>
  `
}

export default headerClient
